import { Button, Col, Form, Input, Row, message } from 'antd';
import { Auth } from 'aws-amplify';
import React from 'react';
import { useHistory, useLocation } from 'react-router';

import { IAuthProps } from '../../pages/Authentication';
import { redirectToLogin } from '../utils';
import styles from './Auth.module.css';
import { CardWithTitle, CodeFormInput, error, goto } from './utils';

const ConfirmSignUp: React.FC<IAuthProps> = ({
  form,
  authData,
  onStateChange,
  authState,
  onAuthEvent,
  code,
  email,
}) => {
  const { pathname } = useLocation();
  const { push } = useHistory();
  const [loading, setLoading] = React.useState<boolean>(false);

  const confirmCode = React.useCallback(
    values => {
      setLoading(true);
      Auth.confirmSignUp(values.email, values.code)
        .then(() => {
          setLoading(false);
          redirectToLogin(push);
          onStateChange('signIn', {});
          message.success('Successfully confirmed, please log in');
        })
        .catch(err2 => {
          if (
            err2.message ===
            'User cannot be confirmed. Current status is CONFIRMED'
          ) {
            setLoading(false);
            redirectToLogin(push);
            onStateChange('signIn', {});
            message.success('User was already confirmed, please log in');
          } else {
            setLoading(false);
            error(err2, authState, onAuthEvent);
          }
        });
    },
    [onAuthEvent, authState, push, setLoading, onStateChange]
  );

  const resendCode = React.useCallback(() => {
    Auth.resendSignUp(email || authData).catch(err =>
      error(err, authState, onAuthEvent)
    );
  }, [authData, authState, email, onAuthEvent]);

  return (
    <CardWithTitle title="Account Confirmation">
      <Form
        form={form}
        onFinish={confirmCode}
        className="confirm-form"
        initialValues={{ email: email || authData, code }}
      >
        <Form.Item name="email">
          <Input
            size="large"
            disabled={(email || authData).length > 0}
            placeholder="Email Address"
          />
        </Form.Item>
        <CodeFormInput />
        <div id="blue-link" onClick={resendCode}>
          Resend Code
        </div>
        <Row justify="space-around" align="middle">
          <Col>
            <Button
              type="primary"
              shape="round"
              ghost={true}
              onClick={goto('signIn', push, pathname, onStateChange)}
              className={styles.signupBackButton}
            >
              Back to Sign In
            </Button>
          </Col>
          <Col>
            <Form.Item className={styles.confirmSignupConfirmFormItem}>
              <Button
                loading={loading}
                type="primary"
                size="large"
                shape="round"
                htmlType="submit"
                className={styles.signupCreateButton}
              >
                Confirm
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </CardWithTitle>
  );
};

export default ConfirmSignUp;
